import React from 'react';
import AlertDialog from 'components/AlertDialog';
import LinkConstants from 'constants/LinkConstants';

export interface Props {
  errorMessage: string;
  onRequestHide: () => void;
}

const BlockedContentDialog = ({ errorMessage, onRequestHide }: Props) => (
  <AlertDialog
    onRequestHide={onRequestHide}
    size="small"
    title="Message not sent"
    subtext={errorMessage}
    buttonText="Review community guidelines"
    onOkay={() => window.open(LinkConstants.COMMUNITY_GUIDELINES, '_blank')}
  />
);

export default BlockedContentDialog;
